// Partenaires : structures avec lesquelles la thérapeute a travaillé ou
// contribué, rangées par catégorie de service (voir serviceCategories dans
// servicesContent.js).
// - Page /services : bandeau défilant des partenaires de l'onglet affiché.
// - Page d'accueil : bandeau avec l'ensemble des partenaires (allPartners).
//
// - logo : fichier dans public/partenaires/. Tant qu'il est absent (null),
//   le nom du partenaire s'affiche à la place.
// - url : site officiel (lien au clic sur le logo), ou null.

const partner = (id, name, location, logo, url = null) => ({ id, name, location, logo, url });

export const partnersByCategory = {
  organismes: {
    title: "Ils m'ont fait confiance",
    partners: [
      partner("la-maisonnee", "La Maisonnée", "Montréal", "/partenaires/la-maisonnee.svg", "https://lamaisonnee.org/fr/"),
      partner("aiem", "AIEM — Accueil aux immigrants de l'Est de Montréal", "Montréal", "/partenaires/aiem.png", "https://aiemont.com/fr/accueil"),
      partner("ymca", "YMCA", "Montréal", "/partenaires/ymca.svg", "https://www.ymcaquebec.org/fr"),
      partner("centre-femmes-haut-richelieu", "Centre de femmes du Haut-Richelieu", "Québec", "/partenaires/centre-femmes-haut-richelieu.jpg", "https://www.collectivementelles.ca/"),
      partner("horizon-carriere", "Horizon Carrière", "Montréal", "/partenaires/horizon-carriere.png", "https://www.horizoncarriere.ca/"),
      partner("reseau-reussite-montreal", "Réseau réussite Montréal", "Montréal", "/partenaires/reseau-reussite-montreal.jpg"),
      partner("tcri", "TCRI — Table de concertation des organismes au service des personnes réfugiées et immigrantes", "Québec", "/partenaires/tcri.jpg"),
      partner("praida", "PRAIDA — Programme régional d'accueil et d'intégration des demandeurs d'asile", "Montréal", "/partenaires/praida.jpg"),
      partner("sosfed", "SOSFED — Réseau SOS Femmes en détresse", null, "/partenaires/sosfed.jpg"),
      partner("cisp", "CISP — Comité International pour le Développement des Peuples", null, "/partenaires/cisp.webp"),
      partner("sos-villages-enfants-draria", "SOS Villages d'Enfants — Draria", "Algérie", null),
      partner("clinique-montfleuri-saint-roch", "Clinique Psychiatrique Montfleuri Saint Roch", "Marseille", "/partenaires/clinique-montfleuri-saint-roch.png", "https://saintroch-montfleuri.fr/"),
      partner("ilhup", "ILHUP — Intervenants Libéraux et Hospitaliers Unis pour le Patient", null, "/partenaires/ilhup.jpg"),
      partner("mdph", "MDPH — Maison départementale des personnes handicapées", null, "/partenaires/mdph.jpg"),
      partner("metropole-aix-marseille-provence", "Métropole Aix-Marseille-Provence", "Marseille", "/partenaires/metropole-aix-marseille-provence.jpg"),
      partner("sdis-25", "SDIS 25 — Sapeurs-pompiers du Doubs", "Doubs", "/partenaires/sdis-25.jpg"),
      partner("centrale-mediterranee", "Centrale Méditerranée", "Marseille", "/partenaires/centrale-mediterranee.avif"),
      partner("institut-calem", "Institut CALEM", "Marseille", "/partenaires/institut-calem.jpg", "https://www.calem.eu/"),
      partner("regie-quartier-grenoble", "Régie de quartier de Grenoble", "Grenoble", "/partenaires/regie-quartier-grenoble.jpg", "https://www.linkedin.com/company/r%C3%A9gie-de-quartier-grenoble/"),
    ],
  },
  groupes: {
    title: "Ils m'ont ouvert leurs portes",
    partners: [
      partner("centre-lgbtqia-marseille", "Centre LGBTQIA+ Marseille", "Marseille", "/partenaires/centre-lgbtqia-marseille.jpg"),
      partner("les-minots-de-noailles", "Les Minots de Noailles", "Marseille", "/partenaires/les-minots-de-noailles.jpg"),
    ],
  },
  "prises-de-parole": {
    title: "Ils m'ont donné la parole",
    partners: [
      partner("la-voix-des-assos", "La Voix des Assos", "Marseille", "/partenaires/la-voix-des-assos.jpg", "https://lavoixdesassociations.com/"),
      partner("festival-aoziz", "Festival AOZIZ", "Marseille", "/partenaires/festival-aoziz.png", "https://www.aoziz.com/"),
      partner("massalia-vox", "Massalia Vox", "Marseille", "/partenaires/massalia-vox.jpg"),
      partner("ieac", "IEAC — Institut d'études et d'actions citoyennes", null, "/partenaires/ieac.jpg", "https://institutdetudesetdactionscitoyennes.org/"),
      partner("institut-des-ameriques", "Institut des Amériques", null, "/partenaires/institut-des-ameriques.jpg"),
      partner("ueeh", "UEEH", null, "/partenaires/ueeh.svg", "https://www.ueeh.net/fr/accueil/"),
      partner("ecole-kourtrajme-dakar", "École Kourtrajmé Dakar", "Dakar", "/partenaires/ecole-kourtrajme-dakar.jpg"),
      partner("kinin", "Kinin", null, "/partenaires/kinin.jpg"),
      partner("amadev", "AMADeV — « À Mon Avis de Vous »", null, "/partenaires/amadev.png"),
    ],
  },
};

// Tous les partenaires, toutes catégories confondues (bandeau de l'accueil).
export const allPartners = Object.values(partnersByCategory).flatMap((c) => c.partners);
